export const findPartCode = (item) => {
  if (!item) {
    return undefined;
  }
  if (item.partSwitch && item.partSwitch.partCategory) {
    return item.partSwitch.partCategory;
  }
  if (item.groupType) {
    return item.groupType;
  }
  if (item.materialSwitch && item.materialSwitch.type) {
    return item.materialSwitch.type;
  }
  return undefined;
};
